/**
 * @bos/portal3 — a curated list of common small-business types (M6).
 *
 * This is CLIENT-side presentation metadata only: the server stores `industry` as free
 * text (any string up to 80 chars), so this list can grow or change without a migration.
 * "Other" switches the create/edit form to a free-text field, so nothing here boxes an
 * owner out of describing their business in their own words. The factory will later read
 * the stored value; it is decoupled from this list.
 */
export const INDUSTRY_OPTIONS = [
  'Food & drink',
  'Retail & shops',
  'Beauty & wellness',
  'Health & fitness',
  'Home & trades',
  'Professional services',
  'Automotive',
  'Events & hospitality',
  'Arts & crafts',
  'Education & tutoring',
  'Real estate & property',
  'Nonprofit & community',
] as const;

/** The sentinel the dropdown uses to reveal a free-text field. */
export const INDUSTRY_OTHER = 'Other';
